import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function sendPasswordResetLink(userId: string): Promise<IApiResponse<any>> {
    const endpoints = await getEndpoints();
    const endpoint = endpoints.changePassword(userId);
    return await apiRequest<any>(endpoint, "PATCH");
} 